import { render } from "./AttractionPage.vue?vue&type=template&id=29dcab42&scoped=true"
import script from "./AttractionPage.vue?vue&type=script&lang=js"
export * from "./AttractionPage.vue?vue&type=script&lang=js"

import "./AttractionPage.css?vue&type=style&index=0&id=29dcab42&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29dcab42"]])

export default __exports__